import { render, staticRenderFns } from "./FormattedInput.vue?vue&type=template&id=6da9950e&"
import script from "./FormattedInput.vue?vue&type=script&lang=js&"
export * from "./FormattedInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports